module.exports = __webpack_public_path__ + "media/pdfs/ppf_terms-40d27af7f96283c64834602d9dc4c1f7.pdf";